import { api_url } from "../utils/ApiContext";
import { deleteRequest, getRequest, putRequest } from "./apiCommon";
import { FotoBeneModel, RiordinaFotoRequest } from "../models/FotoBeneModel";
import { axiosClient } from "./client";

/**
 * Ottieni tutte le foto di un BeneContratto
 */
export const fetchFotoBene = (id_bene_contratto: number) => {
  return getRequest<FotoBeneModel[]>(
    api_url.concat("/api/benecontratto/", id_bene_contratto.toString(), "/foto")
  );
};

/**
 * Upload nuova foto
 */
export const uploadFotoBene = (
  id_bene_contratto: number,
  foto: File,
  is_principale: boolean = false,
  ordine?: number
) => {
  const formData = new FormData();
  formData.append("foto", foto);
  formData.append("is_principale", is_principale ? "1" : "0");
  if (ordine !== undefined) {
    formData.append("ordine", ordine.toString());
  }

  return axiosClient.post(
    api_url.concat("/api/benecontratto/", id_bene_contratto.toString(), "/foto"),
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
        "Accept": "application/json",
        "Access-Control-Allow-Origin": true,
        "X-Requested-With": "XMLHttpRequest",
      },
      withCredentials: true,
      timeout: 120000, // 120 secondi
      maxContentLength: 20 * 1024 * 1024, // 20MB
      maxBodyLength: 20 * 1024 * 1024, // 20MB
    }
  );
};

/**
 * Elimina una foto
 */
export const deleteFotoBene = (id: number) => {
  return deleteRequest(api_url.concat("/api/foto/", id.toString()));
};

/**
 * Imposta foto come principale
 */
export const setFotoPrincipale = (id: number) => {
  return putRequest(
    api_url.concat("/api/foto/", id.toString(), "/principale"),
    {}
  );
};

/**
 * Aggiorna ordine di una foto
 */
export const updateOrdine = (id: number, ordine: number) => {
  return putRequest(api_url.concat("/api/foto/", id.toString()), { ordine });
};

/**
 * Riordina tutte le foto
 */
export const riordinaFoto = (
  id_bene_contratto: number,
  data: RiordinaFotoRequest
) => {
  return putRequest(
    api_url.concat(
      "/api/benecontratto/",
      id_bene_contratto.toString(),
      "/foto/riordina"
    ),
    data
  );
};
